import listBullet from '../../../../../static/images/web-app-development/services/list-bullet.svg';

export const container = ({ width }) => ({
    width,
    position: 'relative',

    tablet: {
        paddingLeft: '5rem',
    },
});

export const extendTitle = {
    title: ({ theme: { colors } }) => ({
        color: colors.white,

        marginTop: '5.5rem',
        marginBottom: '2rem',

        position: 'relative',
        zIndex: 3,
    }),
};

export const extendText = {
    text: ({ theme: { colors } }) => ({
        color: colors.white,
        maxWidth: '40.125rem',
        marginRight: '2.1875rem',

        position: 'relative',
        zIndex: 3,
    }),
};

export const list = {
    paddingLeft: '1rem',
    marginTop: '0',
};

export const listItem = {
    listStyleType: 'none',
    listStyleImage: `url(${listBullet})`,
    margin: 0,
    marginBottom: '1rem',
    padding: 0,
    textIndent: 0,
    fontSize: '1.125rem',
};

export const listItemContainer = {
    position: 'relative',
    left: '0.625rem',
    fontWeight: 'normal',
    margin: 0,
    fontSize: '1.125rem',
};

export const textContainer = {
    display: 'flex',
    flexDirection: 'column',

    tabletLarge: {
        flexDirection: 'row',
    },
};

export const link = ({ theme: { colors } }) => ({
    color: colors.cyan,

    ':visited': {
        color: colors.cyan,
    },
});
